import $ from "jquery";
import Vue from "vue";
import * as ers from "../../../errorsmessages/errors";
import * as suc from "../../../successmessages/success";
import * as rt from "../../../routes/routes";
import * as ses from "../../../configurations/session/sessioncomplete";
import baseurl from "../../../configurations/baseurl/baseurl";
import router from "../../../router/index";

export const actions = {
  newShipping() {
    let shipping = {
      fileopening_id: $(".fileopening_id").val(),
      manifest_no: $(".manifest_no").val(),
      shippingline_charges: $(".shippingline_charges").val(),
      secured_do: $(".secured_do").val(),
      do_status: $('.do_status').val(),
      do_received_date: $(".do_received_date").val(),
      do_remark: $(".do_remark").val(),
      doc_remark: $(".doc_remark").val(),
      doc_date: $(".doc_date").val()
      
    };
    $(".creatingShippingDepartment").hide();
    $(".creatingShippingDepartmentLoader").show();
    baseurl.post(rt.newShipping, shipping).then(res => {
      $(".creatingShippingDepartment").show();
      $(".creatingShippingDepartmentLoader").hide();

      //checking response codes from backend api

      if (res.data.code === 200) {
        //success code
        suc.shippingCreateSuccess();
        router.push("/manageshippingdepartment");
      } else if (res.data.code === 402) {
        //validation code
        ers.validateErrors();
      } else if (res.data.code === 403) {
        //fileopening exits in shipping
        ers.ShippingExists();
      } else if (res.data.code === 404) {
        //error on creating
        ers.errorCreatingShipping();
      } else if (res.data.code === 405) {
        //no permission to create
        ers.noPermissionToCreate();
        router.push("/dashboard");
      } else if (res.data.code === 506) {
        //session expired
        ses.sessionComplete();
      }
    });
  },

  loadShipping({ commit }) {
    baseurl.get(rt.loadShippings).then(res => {
      $(".shippingsLoader").hide();
      //checking response codes from backend api

      if (res.data.code === 200) {
        //success code and mutations
        commit("STORE_SHIPPINGS", res.data.shippings);
      } else if (res.data.code === 404) {
        //error on loading shipping details
        ers.errorLoadingShipping();
      } else if (res.data.code === 405) {
        //no permission to read
        commit("STORE_SHIPPINGS", []);
        ers.noPermissionToRead();
        router.push("/dashboard");
      } else if (res.data.code === 506) {
        //session expired
        ses.sessionComplete();
      }
    });
  },

  loadShippingfiles({ commit }) {
    baseurl.get(rt.loadShipping).then(res => {
      $(".shippingfilesLoader").hide();
      //checking response codes from backend api

      if (res.data.code === 200) {
        //success code and mutations
        commit("STORE_SHIPPING", res.data.shippingfiles);
      } else if (res.data.code === 404) {
        //error on loading shipping details
        ers.errorLoadingShipping();
      } else if (res.data.code === 405) {
        //no permission to read
        commit("STORE_SHIPPING", []);
        ers.noPermissionToRead();
        router.push("/dashboard");
      } else if (res.data.code === 506) {
        //session expired
        ses.sessionComplete();
      }
    });
  },

  viewShipping({ commit }, shippingId) {
    commit("STORE_SHIPPING_UPDATE", shippingId);
    router.push("/updateshippingdepartment");
  },
  viewShippingfile({ commit }, fileopeningId) {
    commit("STORE_SHIPPINGS_UPDATE", fileopeningId);
    router.push("/newcustomrelease");
  },

  shippingUpdate({ commit }) {
    let shipping = {
      id: $(".id").val(),
      fileopening_id: $(".fileopening_id").val(),
      manifest_no: $(".manifest_no").val(),
      shippingline_charges: $(".shippingline_charges").val(),
      secured_do: $(".secured_do").val(),
      do_status: $('.do_status').val(),
      do_received_date: $(".do_received_date").val(),
      do_remark: $(".do_remark").val(),
      doc_remark: $(".doc_remark").val(),
      doc_date: $(".doc_date").val()
    };
    $(".updatingShippingDepartment").hide();
    $(".updatingShippingDepartmentLoader").show();

    baseurl.post(rt.updateShipping, shipping).then(res => {
      $(".updatingShippingDepartment").show();
      $(".updatingShippingDepartmentLoader").hide();

      //checking response codes from backend api

      if (res.data.code === 200) {
        //validation code
        suc.shippingUpdateSuccess();
        commit("STORE_SHIPPINGS", res.data.shippings);
        setTimeout(() => {
          router.push("/manageshippingdepartments");
        }, 3000);
      } else if (res.data.code === 402) {
        //validation code
        ers.validateErrors();
      } else if (res.data.code === 404) {
        //error on updating data
        ers.errorUpdatingShipping();
      } else if (res.data.code === 405) {
        //no permission to update
        ers.noPermissionToUpdate();
        router.push("/dashboard");
      } else if (res.data.code === 506) {
          //session expired
          ses.sessionComplete()
      }
    });
  }
};
export default actions;



// WEBPACK FOOTER //
// ./src/vuex/modules/shippings/actions.js